import styles from "./ViewToggleButton.module.less";
import { Icon } from "../../shared/Icon/Icon";
import { useViewMode } from "../../../stores/viewModeStore";
import { useState } from "react";
import { useThemeStore } from "../../../stores/themeStore";

const ViewToggleButton = () => {
  const { toggleViewMode, viewMode } = useViewMode();
  const [isRotated, setIsRotated] = useState(false);
  const { theme } = useThemeStore();

  const handleClick = () => {
    setIsRotated(!isRotated);
    toggleViewMode();
  };

  return (
    <div
      onClick={handleClick}
      className={`${styles.viewToggleButton}  ${theme !== "light" && styles.viewToggleButton__dark} ${viewMode !== "list" && styles.viewToggleButton__grid}`}
    >
      <Icon
        id={viewMode !== "list" ? "list" : "grid"}
        className={`${styles.icon} ${theme !== "light" ? styles.iconLight : ""}`}
      />
    </div>
  );
};

export default ViewToggleButton;
